import { Stack } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";

const teamAni = {
  offscreen: { y: 50, opacity: 0 },
  onscreen: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", bounce: 0.1, duration: 0.6 },
  },
};
function Avatar({ img }) {
  return (
    <Stack
      // bgcolor="#fff"
      direction="column"
      component={motion.div}
      variants={teamAni}
      width={{
        xs: "12rem",
        sm: "11rem",
        md: "11rem",
        lg: "12rem",
        xl: "13rem",
      }}
    >
      <img
        alt="team"
        src={img}
        style={{
          height: "auto",
          width: "100%",
        }}
      />
    </Stack>
  );
}

export default Avatar;
